
const FlagOne = () => {
    const stripeColor = "#B22234"; 
    const cantonColor = "#3C3B6E";

    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="21"
            viewBox="0 0 40 21"
            aria-label="Flag of the United States"
        >
            <rect width="40" height="21" fill="#FFFFFF"/>

            <rect width="40" height="1.615" y="0" fill={stripeColor}/>
            <rect width="40" height="1.615" y="3.23" fill={stripeColor}/>
            <rect width="40" height="1.615" y="6.46" fill={stripeColor}/>
            <rect width="40" height="1.615" y="9.69" fill={stripeColor}/>
            <rect width="40" height="1.615" y="12.92" fill={stripeColor}/>
            <rect width="40" height="1.615" y="16.15" fill={stripeColor}/>
            <rect width="40" height="1.615" y="19.38" fill={stripeColor}/>
            
            <rect width="18" height="11.3" y="0" x="0" fill={cantonColor}/>
        </svg>
    );
};

export default FlagOne;